import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import { IOrderAcceptanceService, CHANNEL_ACCEPTANCE_SERVICE } from "../IOrderAcceptanceService";
import { BasePrimaryActionService } from "./BasePrimaryActionService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class OrderAcceptancePromiseService
  extends BasePrimaryActionService
  implements IOrderAcceptanceService
{
  abstract requestAcceptance(
    ids: Array<string>,
    comment: string,
    acceptanceAction: CubiqTS.AcceptanceAction,
    acceptanceType: CubiqTS.AcceptanceType,
    targetGroupId?: string,
    callOrderRateSide?: CubiqTS.RateSideType,
    orderType?: CubiqTS.OrderType,
    benchmarkOrderType?: CubiqTS.BenchmarkOrderType,
  ): Promise<any[]>;
  abstract getModelNotificationFailureEventSubject(): Subject<CubiqTS.ConcreteEncodable>;
}
